import React, { createContext, useContext, useEffect, useState } from 'react';

const FavoritesContext = createContext(null);
const KEY = 'dm_favorites';

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState([]); // Array of listing IDs

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setFavorites(JSON.parse(raw));
    } catch {}
  }, []);

  const persist = (next) => {
    setFavorites(next);
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
  };

  const isFavorite = (id) => favorites.includes(id);
  const add = (id) => { if (!favorites.includes(id)) persist([...favorites, id]); };
  const remove = (id) => persist(favorites.filter((f) => f !== id));
  const toggle = (id) => isFavorite(id) ? remove(id) : add(id);
  const clear = () => persist([]);

  return (
    <FavoritesContext.Provider value={{ favorites, isFavorite, add, remove, toggle, clear, count: favorites.length }}>
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(FavoritesContext);
